import React, { useRef, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { systemConstants } from "../../../constants";
import { CancelIcon } from "../../../assets/images/icon/iconsProvider";

const CustomModal = (props) => {
  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );

  const navigator = useNavigate();
  const modalRef = useRef(null);

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      props.setShow(false);
    }
  };

  const handleShow = (e) => {
    if (props.isMoveToWP) {
      window.location.href =
        process.env.REACT_APP_MARKETING_SITE_URL + systemConstants.LANGUAGE;
    } else if (props.isMoveBack) {
      if (props.onClose) {
        props.onClose();
        return;
      }
      navigator(-1);
    } else {
      e.stopPropagation();
      e.preventDefault();
      props.setShow(false);
    }
  };

  useEffect(() => {
    if (props.closeOnOutsideClick) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
    // eslint-disable-next-line
  }, [props.closeOnOutsideClick]);

  return (
    <Modal
      centered={true}
      size={props.size}
      backdrop="static"
      show={props.show}
      className={props.customClass}
      scrollable={props.scrollable}
      onHide={() => props.setShow(false)}
      onEscapeKeyDown={(e) => handleShow(e)}
    >
      <Modal.Body dir={direction} ref={modalRef}>
        <span
          onClick={(e) => handleShow(e)}
          className={props.closeBtnClasses || "modal-close-icon"}
        >
          <CancelIcon />
        </span>
        {props.children}
      </Modal.Body>
    </Modal>
  );
};

export default CustomModal;
